import candidateCommunicationImage from "@/assets/case-study-recruitment-communication-hero.jpg";
import physiotherapyVisibilityImage from "@/assets/case-scenario-physio-visibility-hero.jpg";
import financialOnboardingImage from "@/assets/case-scenario-financial-onboarding-hero.jpg";
import ecommerceReturnsImage from "@/assets/case-scenario-ecommerce-returns-hero.jpg";
import hotelDirectBookingsImage from "@/assets/case-scenario-hotel-direct-bookings-hero.jpg";
import lettingsResponseImage from "@/assets/case-scenario-lettings-response-hero.jpg";
import supplierQueriesImage from "@/assets/case-scenario-supplier-queries-hero.jpg";
import type { CaseStudy } from "@/data/caseStudies";

export const caseScenarios: CaseStudy[] = [
  {
    slug: "/case-scenarios/construction-supplier-query-response",
    image: supplierQueriesImage,
    category: "Construction",
    date: "2 November 2026",
    title: "We cut supplier query response time by 85% for a mid sized construction firm",
    listingTitle: "A supplier query takes three days because nobody owns it.",
    excerpt: "Supplier queries took three days because nobody owned them from start to finish. Here is what tracing twelve of them showed and how response time fell 85%.",
    author: "Ayomide Oke",
    readTime: "4 min read",
  },
  {
    slug: "/case-scenarios/lettings-agency-enquiry-response",
    image: lettingsResponseImage,
    category: "Property",
    date: "October 2026",
    title: "How a lettings agency stopped losing tenants",
    listingTitle: "The first agent to reply usually wins the viewing.",
    excerpt:
      "A lettings agency lost applicants to whoever replied first, as evening and weekend enquiries waited until morning. Here is how reply time fell to 3 minutes.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },

  {
    slug: "/case-scenarios/boutique-hotel-direct-bookings",
    image: hotelDirectBookingsImage,
    category: "Hospitality",
    date: "October 2026",
    title: "How a 28-room boutique hotel won back direct bookings from the booking platforms",
    listingTitle: "Guests wanted to book direct. Nobody replied in time.",
    excerpt: "A 28 room boutique hotel lost direct bookings to platforms because enquiries waited hours for a reply. Here is how response time fell from 5 hours to 2 minutes.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/case-scenarios/ecommerce-returns-processing",
    image: ecommerceReturnsImage,
    category: "Ecommerce",
    date: "October 2026",
    title: "We cut returns processing time by 73% for a growing ecommerce retailer",
    listingTitle: "An 8 day wait for a refund that needed no decision.",
    excerpt: "Customers waited 8 days for refund decisions that needed no judgement. Here is how returns processing time fell 73% and negative reviews about returns fell 79%.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/case-scenarios/enterprise-financial-services-onboarding",
    image: financialOnboardingImage,
    category: "Financial services",
    date: "October 2026",
    title: "We redesigned client onboarding for an enterprise financial services provider",
    listingTitle: "Six hours of work took six weeks. Nobody had asked why.",
    excerpt:
      "A financial services onboarding process involved under six hours of actual work spread across six weeks. Here is where the time was going and what changed when the handoffs stopped waiting for someone to notice.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/case-scenarios/physiotherapy-group-performance-visibility",
    image: physiotherapyVisibilityImage,
    category: "Healthcare",
    date: "October 2026",
    title: "We gave a six site physiotherapy group visibility it had never had before",
    listingTitle: "Leadership thought they knew which site was struggling.",
    excerpt:
      "A physiotherapy group believed its newest site was underperforming. Once the numbers were normalised properly, the opposite was true.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
  {
    slug: "/case-scenarios/candidate-communication-automation",
    image: candidateCommunicationImage,
    category: "Recruitment",
    date: "September 2026",
    title: "Good candidates were dropping out of process not because of the roles, but because of how long it took to hear back",
    listingTitle: "Candidates were not leaving over the role. They left over silence.",
    excerpt:
      "A modelled scenario showing what can change when a recruitment agency replaces manual candidate follow up with consistent, timely communication.",
    author: "Ayomide Oke",
    readTime: "5 min read",
  },
];